import { Attachment } from "@/models/attachment";

export interface ConfigData {
  usdToVND: number;
  idrToVND: number;
  vat: number;
  viewContract: number;
  shareLimitPage: number;
  shareLimit: number;
  monthActiveSubscription: number;
  urlAi: string;
  viewDemoLink: {
    url: any;
    method: number;
  };
  currency?: string;
}

export interface Config {
  id: number;
  name: string;
  key: string;
  value: string;
  type: ConfigType;
  method: number;
  attachment?: Attachment;
  createdAt: Date;
  updatedAt: Date;
}

export enum MethodConfig {
  YOUTUBE = 1,
  SUPADEMO = 2,
}

export enum ConfigType {
  number = "number",
  attachment = "attachment",
}
